import { Globe } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

export type GlobeIconProps = ComponentPropsWithoutRef<typeof Globe>;

export function GlobeIcon({ className, ...props }: GlobeIconProps) {
  return <Globe className={cn('size-icon-sm', className)} {...props} />;
}
